import { customElement, property } from 'lit/decorators.js';
import { chatbotEscalationPillStyles } from './ChatbotEscalationPill.styles';
import { Pill } from '@atlas/shared/client/ui/wc/components/pill';
import { t } from 'i18next';
import { chatbotMessageContext, type ChatbotMessageContext } from '../chatbot-message/ChatbotMessageContext';
import { consume } from '@lit/context';
import { sleep } from '@atlas/shared/client/ui/core/utils';
import { ChatbotService } from '@atlas/shared/data-access/chatbot';

@customElement('lr-chatbot-escalation-pill')
export class ChatbotEscalationPill extends Pill {
    @property({ type: String })
    channel = '';
    @property({ type: Boolean })
    shouldGetSummary = false;

    @consume({ context: chatbotMessageContext })
    messageContext?: ChatbotMessageContext;

    static styles = [Pill.styles, chatbotEscalationPillStyles];

    connectedCallback() {
        super.connectedCallback();
    }

    private getUrl(message?: string) {
        return t('chatbot:escalation.url', { context: this.channel, message });
    }

    override async handleClick() {
        super.handleClick();
        await this.escalate();
    }

    private trackEscalation() {
        const chatbotEscalationEvent = new CustomEvent('chatbotEscalationClicked', { detail: this.channel });
        window.dispatchEvent(chatbotEscalationEvent);
    }

    private async escalate() {
        let message = '';
        if (this.shouldGetSummary) {
            if (this.messageContext?.conversationId) {
                const conversationId = this.messageContext.conversationId;
                this.loading = true;
                try {
                    const service = new ChatbotService({
                        baseURL: this.messageContext.apiUrl,
                        withCredentials: true,
                        method: 'POST'
                    });

                    const { ticketId } = await service.chatbotConversationsInteractionsSummarizePost(
                        { id: conversationId },
                        {
                            language: this.language,
                            origin: ''
                        }
                    );

                    const prefixedTicketId = this.channel === 'whatsapp' ? `HERMES ${ticketId}` : ticketId;
                    message = t('chatbot:escalation.message', {
                        context: this.channel,
                        conversationId: prefixedTicketId
                    });
                    await sleep(200);
                } catch {
                } finally {
                    this.loading = false;
                }
            }
        }
        this.trackEscalation();
        const url = this.getUrl(message);
        if (url) {
            window.open(url, '_blank');
        }
    }
}
